import React from 'react';
import PhoneInput from 'core/components/PhoneInput';
import {
  FieldComponentProps,
} from 'views/EMR/components/FillableForm/types';

export default function Phone({
  field,
  value,
  onChange,
  error,
}: FieldComponentProps) {
  return (
    <PhoneInput
      id={field?.id ?? ''}
      name={field?.id ?? 'phone'}
      autoFocus
      error={error}
      value={(value?.value ?? '') as string}
      onChange={(number) => {
        onChange?.({ ...value, value: number?.toString() });
      }}
    />
  );
}
